import { useNavigate } from "react-router-dom";
import { changePasswordService } from "../../../Services/AuthService";
import {
  changePasswordError,
  changePasswordStart,
  changePasswordSuccess,
} from "./reducer";

export const changePasswordThunk = (id, data, history) => async (dispatch) => {
  try {
    dispatch(changePasswordStart());
    const response = await changePasswordService(id, data);

    if (response.success) {
      dispatch(
        changePasswordSuccess(
          response?.message || "Password changed successfully."
        )
      );
      setTimeout(() => {
        history("/dashboard");
      }, 3000);
    } else {
      dispatch(changePasswordError(response?.message));
    }
  } catch (error) {
    dispatch(changePasswordError(error));
  }
};
